/*
 * BadgeBTC
 * @module components/Badges
 * @flow
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Badge } from '../';
import IconDepositBalanceEn from '@/icons/ic-v-badge-en.png';
import IconDepositBalanceCn from '@/icons/ic-v-badge-cn.png';

import messages from './messages';

export type BadgeBTCProps = {
  size?: number,
};

/**
 * BadgeBTC React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {number} [props.size] - size
 * @param {locale} [props.locale] - locale
 * @example <caption>Simple usage</caption>
 * <BadgeBTC />
 * @returns {React.Node<*>} React-component
 */
export const BadgeBTC = ({ size, locale = 'en' }: BadgeBTCProps) => (
  <Badge
    icon={locale === 'en' ? IconDepositBalanceEn : IconDepositBalanceCn}
    size={size}
    testid="badgebtc"
    tooltip={<FormattedMessage {...messages.btcVoucher} />}
  />
);
